const AddPhotoAlternate = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h360v80H200v560h560v-360h80v360q0 33-23.5 56.5T760-120H200Zm80-160h400L545-460 440-320l-65-87-95 127Zm400-320v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80ZM480-480Z"/>
        </svg>
    )
}

export default AddPhotoAlternate;

